var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames, entityPluralLabel } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EntityMultiValue } from './entity-multi-value';
import { CellHeader } from '../elements/cell-header';
import { trim } from 'lodash';
import { EntityLink } from './entity-link';
var cls = classNames('entity-multi-value-list');
export var EntityMultiValueListDefaultProps = {
  items: [],
  useLinks: false,
  background: "app-chrome"
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValuesStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "], ["\n    margin-top: ", ";\n    display: flex;\n    flex-wrap: wrap;\n  "])), theme.UNIT(2))
});
var LinkStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "], ["\n    margin-bottom: ", ";\n    margin-right: ", ";\n\n    ", "\n\n  "])), theme.UNIT(2), theme.UNIT(2), function (props) {
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), theme.COLOR(props._background));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(CellHeader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Values: styled.div.attrs(cls.attr('values'))(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValuesStyles),
  Link: styled(EntityLink)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: styled(EntityMultiValue)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var EntityMultiValueList = function (props) {
  var className = props.className,
    _a = props.items,
    items = _a === void 0 ? [] : _a,
    useLinks = props.useLinks,
    background = props.background,
    valueProps = __rest(props, ["className", "items", "useLinks", "background"]);
  if (!items.length) {
    return null;
  }
  var headerLabel = props.headerLabel || entityPluralLabel(items[0]);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, headerLabel && React.createElement(My.Header, null, trim(headerLabel, ":"), ":"), React.createElement(My.Values, null, items.map(function (item) {
    var value = React.createElement(My.Value, __assign({
      _background: background,
      key: item.id,
      entity: item
    }, valueProps));
    return useLinks ? React.createElement(My.Link, {
      entity: item
    }, value) : value;
  })));
};
EntityMultiValueList.defaultProps = EntityMultiValueListDefaultProps;
EntityMultiValueList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;